import { authService } from './services/auth.js';
import { backboneService } from './services/backbone.js';
import './services/entitlements-service.js';
import "./components/hat-router.js";
import "./components/hat-login.js";
import "./components/hat-logout.js";
import "./components/hat-welcome.js";
import "./components/hat-app-landing.js";
import "./components/hat-nav-button.js";
import "./components/hat-camera-capture.js";
import "./components/hat-file-upload.js";
import "./components/hat-qr-reader.js";
import "./components/hat-asset-link-form.js";
import "./components/hat-user-profile.js";
import "./components/hat-image.js";
import "./components/hat-private-beta.js"
import "./components/hat-not-found.js";
import "./components/hat-error.js";

import "./components/layouts/hat-layout-app.js";
import "./components/layouts/hat-layout-home.js";
import "./components/layouts/hat-layout-admin.js";

import "./components/admin/hat-admin-users.js";
import "./components/admin/hat-admin-user-form.js";
import "./components/admin/hat-admin-invitations.js";
import "./components/admin/hat-admin-invitation-form.js";
import "./components/admin/hat-admin-invitation-detail.js";
import "./components/admin/hat-admin-services.js";
import "./components/admin/hat-admin-testing.js";
import "./components/admin/hat-admin-maintenance-templates.js";
import "./components/admin/hat-admin-asset-type-properties.js";

import "./components/location/hat-locations.js";
import "./components/location/hat-location-form.js";
import "./components/location/hat-location-profile.js";
import "./components/location/hat-asset-card.js";
import "./components/location/hat-asset-form.js";
import "./components/location/hat-asset-profile.js";
import "./components/location/hat-asset-public-profile.js";
import "./components/location/hat-location-card.js";
import "./components/location/hat-maintenance-list.js";
import "./components/location/hat-photo-gallery.js";
import "./components/location/hat-location-gallery.js"


document.addEventListener("click", e => {
    const path = e.composedPath();
    const link = path.find(el =>
        el instanceof HTMLAnchorElement && el.matches("a[data-link]")
    );
    if (!link) return;
    e.preventDefault();
    //backboneService.dispatchToCustomControls("onNavigate", link.getAttribute("href"));
    backboneService.navigateTo((link as HTMLAnchorElement).getAttribute("href"));
});

window.addEventListener('load', () => {
    authService.initialize();
});